var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centerIntro-wrap"},[_c('div',{staticClass:"centerIntro-content"},[_c('div',{staticClass:"title"},[_vm._v("中心简介")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }